import React, {useState} from "react";
import LoadPanel from 'devextreme-react/load-panel';
import SelectCert from "./SelectCert";
import { signFile } from "./utils";
//import { useGetCertificate} from "./utils/hooks";
import {Button} from "devextreme-react/button";

const FileSignatureCryptoPro = ({
  callback,
  onChange = _ => _,
  //onSelect = _=>_,
  file = null,
  files = null,
  clear = false,
  SelectComponent,
  ButtonComponent = props => (
    <Button disabled={'true'} type="default" className="file-signature-crypto-pro__btn mt-2 p-2" {...props}>
      Подписать
    </Button>
  ),
  callbackError = _ => _
}) => {
  const [thumbprint, setThumbprint] = useState(null);
  const [sign, setSign] = useState(null);
  const [fileNameSign, setFileNameSign] = useState(null);
  const [loading, setLoading] = useState(false);
  //const selectCert = useGetCertificate(thumbprint)
  const cleanOut = () => {
    setSign(null);
    setFileNameSign(null);
  };

  if (clear && (sign || fileNameSign)) {
    cleanOut();
  }

  const signing = () => {
    setLoading(true)
    if (file) {
      signFile({ thumbprint, file })
        .then((e) => {
          callback({ fileNameSign: e.fileName, sign: e.blob, rezVerify: e.rezVerify });
          setSign(e.blob);
          setFileNameSign(e.fileName);
        })
        .catch(e => callbackError(String(e))).finally(() => {
        setLoading(false)
      });
    }
    if (files && files.length) {
      const signs = [];

      Promise.all(
        Array.from(files).map(item => {
          return signFile({ thumbprint, file: item }).then((e) => {
            signs.push({ fileNameSign: e.fileName, sign: e.blob, rezVerify: e.rezVerify });
          });
        })
      ).then(() => {
        onChange(signs)
        if(typeof callback === 'function'){
          console.info('callback is deprecated. use onChange')
          callback(signs)
        }
      }).catch(e => callbackError(e))
          .finally(() => {
            //setLoading(false)
          });
    }
  };

  return (
    !sign &&
    /*(file || (files && files.length)) &&*/ (
      <div className="file-signature-crypto-pro">
        <LoadPanel message={'Подпись файла...'} shading={true} visible={loading} />
        {<SelectCert {...{ setThumbprint, callbackError, Component: SelectComponent, value:thumbprint}} />}
        {thumbprint && <ButtonComponent disabled={!thumbprint && !loading} onClick={signing} />}
      </div>
    )
  );
};

export default FileSignatureCryptoPro;
